import { useEffect, useRef, useState } from 'react';

export function useScrollSync() {
  const [el1, setEl1] = useState<HTMLDivElement | null>(null);
  const [el2, setEl2] = useState<HTMLDivElement | null>(null);
  const isSyncingRef = useRef(false);

  useEffect(() => {
    if (!el1 || !el2) return undefined;

    const sync = (source: HTMLElement, target: HTMLElement) => {
      if (isSyncingRef.current) return;
      isSyncingRef.current = true;
      // eslint-disable-next-line no-param-reassign
      target.scrollLeft = source.scrollLeft;
      requestAnimationFrame(() => {
        isSyncingRef.current = false;
      });
    };

    const onScroll1 = () => sync(el1, el2);
    const onScroll2 = () => sync(el2, el1);

    el1.addEventListener('scroll', onScroll1, { passive: true });
    el2.addEventListener('scroll', onScroll2, { passive: true });

    return () => {
      el1.removeEventListener('scroll', onScroll1);
      el2.removeEventListener('scroll', onScroll2);
    };
  }, [el1, el2]);

  return [setEl1, setEl2] as const;
}
